import React from 'react';

const WhoIam = () => (
    <section className="who-i-am presentation-i-am">
        <p>Hola que tal, la verdad no se como empezar mi presentacion, pero aqui voy. Me llamo César Eliud aunque me gusta que me llamen Eliud que César solo por que no hay muchos Eliud's que conozca.</p>
        <p>Soy un joven que estudiante autodidacta, ya que prefiero aprender donde estan actualizados y mas explicados a que un profesor mas desactualizado que los que creen que Microsoft todavia odia al Open Source. Aunque con esto no digo que todos los profesores sean tan malos al enseñar.</p>
        <p>Estudio actualmente en Conalep, y si conoces su fama, no no he hecho nada malo 😅😅. Dejando eso a un lado me gusta mucho la programacion, y desde que empeze con el diseño UI no puedo ver algo desordenado, pero no estoy obsesionado. Tengo 2 gatos para poder tranquilizar mis estres de la programacion.</p>
        
        <p>Ocio:</p>
        <ul>
            <li>Jugar videojuegos como GTA 5</li>
            <li>Me gusta ver anime, ver manga y leer novelas ligeras</li>
            <li>Twitch si, Television no</li>
        </ul>
    </section >
)

export default WhoIam;
